import React, { memo, useEffect, useState } from 'react'
import { LoadingOverlay, Alert } from '@mantine/core'
import { IconAlertCircle } from '@tabler/icons'
import { DittoProvider } from '@ow/ditto-core'
import { TbViewBasic } from '@vt/comps'
import { fetchSharedLinkInfo } from '@vt/apis/lib-ex/v2/share'
import { AppProvider, TbViewProvider, useProjectStore } from '@vt/hooks'
import { getQuery } from '@vt/utils'
import ShareDetail from './shareDetail'

const Share = () => {
  const { tpl, sharedId } = getQuery()

  const [error, setError] = useState()
  const [loading, setLoading] = useState(true)
  const [shareInfo, setShareInfo] = useState(null)
  const setToken = useProjectStore((state) => state.setToken)

  useEffect(() => {
    fetchSharedLinkInfo(sharedId)
      .then((res) => {
        setToken(res.sharedToken)
        setShareInfo(res)
        setLoading(false)
      })
      .catch((err) => {
        console.log(err)
        setError('未查询到分享信息，请联系管理员重新分享')
      })
  }, [sharedId])

  if (error) {
    return (
      <div className="w-screen h-screen relative">
        <Alert
          icon={<IconAlertCircle />}
          className="mx-20 my-10"
          color="red"
          variant="filled"
        >
          {error}
        </Alert>
      </div>
    )
  }

  if (loading) {
    return (
      <div className="w-screen h-screen relative">
        <LoadingOverlay visible />
      </div>
    )
  }

  const { appId, tbId, viewId, queryDsl, sharedSourceType, objectId } =
    shareInfo

  if (sharedSourceType === 'SINGLE_UCASE' && objectId) {
    return (
      <AppProvider appId={appId} tpl={tpl}>
        <DittoProvider tbId={tbId}>
          <TbViewProvider appId={appId} tbId={tbId} vid={viewId}>
            <ShareDetail objectId={objectId} onError={setError} />
          </TbViewProvider>
        </DittoProvider>
      </AppProvider>
    )
  }

  const extendsStore = queryDsl ? () => ({ filters: queryDsl }) : null

  return (
    <AppProvider appId={appId} tpl={tpl}>
      <TbViewBasic
        appId={appId}
        tbId={tbId}
        vid={viewId}
        showNavMenu={false}
        extendsStore={extendsStore}
      />
    </AppProvider>
  )
}

export default memo(Share)
